import * as endPoints from "../../constants/v2/endPoints";
import * as apiService from "../v2/apiService";

export async function checkMessageCompliance(text, tenantConfig) {
  return await apiService.apiCall(
    endPoints.CHECK_MESSAGE_COMPLIANCE,
    "POST",
    { text, tenantConfig },
  );
}

export async function logMessageComplianceFlag({
  chatId,
  recipientUserId,
  surface,
  messageText,
  violations,
  severity,
  wasBlocked,
  wasSent,
}) {
  return await apiService.apiCall(
    endPoints.LOG_MESSAGE_COMPLIANCE,
    "POST",
    {
      chatId,
      recipientUserId,
      surface,
      messageText,
      violations,
      severity,
      wasBlocked,
      wasSent,
    },
  );
}
